export const dividerStyling = { borderLeft: '8px solid', borderLeftColor: 'neutral100' };
